import React from 'react'
import PropTypes from 'prop-types'

const Item = ({ description, children, className }) => (
  <div className={className}>
    <span>{description}</span>
    <p className='fontSize20 mt-1'>{children}</p>
  </div>
)

Item.propTypes = {
  description: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired
}

export default Item



// WEBPACK FOOTER //
// ./src/Participant/Extract/Totalizers/Item.js